import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ExclamationTriangleIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import ModalDelete from '../../../../components/modal-delete/modal-delete';
import storeApi from '../../../../services/storeApi';
import {
  SectionHeading,
  destructiveButtonClass,
} from '../components/settings-ui';

const DangerZoneTab = ({ storeDetail }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dialogs, setDialogs] = useState({
    delete: false,
  });

  const onClickDelete = () => {
    setDialogs((prev) => ({ ...prev, delete: true }));
  };

  const onConfirmDelete = async () => {
    try {
      setLoading(true);
      await storeApi.deleteById(storeDetail.id);
    } catch (error) {
    } finally {
      setDialogs((prev) => ({ ...prev, delete: false }));
      setLoading(false);
      navigate('/dashboard/stores');
    }
  };

  return (
    <div className="space-y-6">
      <SectionHeading
        title="Danger Zone"
        description="Destructive actions that cannot be reversed. Double check before proceeding."
      />

      <div className="relative overflow-hidden rounded-md border border-rose-200/80 bg-gradient-to-br from-rose-50 via-white to-rose-50/40 p-6 shadow-sm dark:border-rose-900/50 dark:from-rose-950/30 dark:via-slate-900/70 dark:to-rose-950/20">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex items-start gap-4">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-rose-500/15 text-rose-600 dark:bg-rose-400/10 dark:text-rose-300">
              <ExclamationTriangleIcon className="h-6 w-6" aria-hidden="true" />
            </div>
            <div className="min-w-0">
              <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">
                Delete this store
              </h3>
              <p className="mt-1 max-w-xl text-sm text-slate-600 dark:text-slate-400">
                Removes{' '}
                <span className="font-semibold">{storeDetail.name}</span> and
                its menus, orders, and historical data. This action cannot be
                undone.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClickDelete}
            disabled={loading}
            className={destructiveButtonClass + ' w-full sm:w-auto'}
          >
            <TrashIcon className="h-5 w-5" aria-hidden="true" />
            Delete Store
          </button>
        </div>
      </div>

      <ModalDelete
        title="Store"
        loading={loading}
        open={dialogs.delete}
        onCloseRequest={() =>
          setDialogs((prev) => ({ ...prev, delete: false }))
        }
        onOk={onConfirmDelete}
        item={storeDetail}
        shouldConfirm={true}
      />
    </div>
  );
};

export default DangerZoneTab;
